import React from "react";
import { Button, withStyles, LinearProgress } from "@material-ui/core";
import { Typography } from "../Wrappers";
import { CircularProgress } from "@material-ui/core/es";

const PageTitle = ({ classes, ...props }) => (
  <div className={classes.pageTitleContainer}>
    
    <Typography className={classes.typo} variant="h1" size="sm">
      {props.title}
    </Typography>
    
    {props.button && (
      <Button
        classes={{ root: classes.button }}
        variant="contained"
        size="large"
        color="secondary"
        onClick={props.buttononClick}
      >
        {props.button}
      </Button>
    )}
  </div>
);

const styles = theme => ({
  pageTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit
  },
  typo: {
    color: '#6e6e6e',//theme.palette.text.hint,
  },
  button: {
    boxShadow: theme.customShadows.widget,
    textTransform: 'none',
    '&:active' : {
      boxShadow: theme.customShadows.widgetWide,
    },
  },
});

export default withStyles(styles)(PageTitle);
